<template>
	<div class="introduction">
		<HNB></HNB>
		<div class="topView">
			<div class="Maintitle">产品介绍视频</div>
		</div>

		<div class="MainView">
			<div class="MainView-box" v-for="item in dataAry" @click="open(item.video_link)">
				<introduceView :name="item.letters" :imgUrl="item.product_img" :honorImg="item.product_honor_img">
				</introduceView>
			</div>
			<div v-for="item in 3" style="width:50% ;"></div>
		</div>

		<bottom :BsTitle="bsTitle"></bottom>

		<dialog-bar v-model="sendVal" type="confirm" title="" :content="tips" v-on:cancel="clickCancel()"
			@danger="clickDanger()" @confirm="clickConfirm()" dangerText="Delete"></dialog-bar>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import introduceView from '../components/introduceView.vue'
	import dialogBar from '../components/dialog.vue'
	import request from '../common/request.js'

	export default {
		name: 'introduction',
		components: {
			HNB,
			bottom,
			introduceView,
			'dialog-bar': dialogBar
		},
		data() {
			return {
				bsTitle: ['产品介绍', '产品介绍视频'],
				sendVal: false,
				tips: '',
				dataAry: []
				// dataAry:[
				// 	{
				// 		svgName: 'CGD',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/eye.png',
				// 		letters: '乐范灵眸眼部按摩仪',
				// 		arr: ''
				// 	}, 
				// 	{
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/bear.png',
				// 		letters: '乐范随身魔力按摩贴',
				// 		arr:'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=E9tlvUDybE&banner_id=f.79991533~image_ad.1~3~e1tjHBnt&reft=1591413329342&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/magicsticker.png',
				// 		letters: '乐范四驱魔力贴熔岩黑',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=zivwz0wklD&banner_id=f.79991533~image_ad.1~3~ZQvaj413&reft=1591413389840&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/egg.png',
				// 		letters: '乐范小摩蛋粉色',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=nMv0ksVSHY&banner_id=f.79991533~image_ad.1~1~LE3gsfIi&reft=1591413480866&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/claw.png',
				// 		letters: '乐范小摩爪珊瑚粉',
				// 		arr: '',
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/eyes.png',
				// 		letters: '乐范眼部冷热按摩仪',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=RKVQ7vIvRs&banner_id=f.79991533~image_ad.1~2~Lu38l78I&reft=1591413688886&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/shapecushion.png',
				// 		letters: '乐范塑形坐垫',
				// 		arr: '',
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/moxibustion.png',
				// 		letters: '艾灸棒',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=4BycUWBJOJ&banner_id=f.79991533~image_ad.1~1~Nl0Ch2kL&reft=1591413748999&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/neckpillow.png',
				// 		letters: '乐范按摩助眠颈枕',
				// 		arr: '',
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/massagechair.png',
				// 		letters: '按摩椅焦糖黄',
				// 		arr: '',
				// 	}, {
				// 		svgName: 'IF',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/neckmassager.png',
				// 		letters: '颈部揉捏按摩仪',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=nUcva7DJYj&banner_id=f.79991533~image_ad.1~6~QDsGGR5l&reft=1591414666922&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/cappa.png',
				// 		letters: '乐范3D揉捏披肩',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=96Z0iltj55&banner_id=f.79991533~image_ad.1~4~uw8YS0ft&reft=1591414651597&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/cushion.png',
				// 		letters: '乐范背部按摩椅垫',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=weWmCXFQe6&banner_id=f.79991533~image_ad.1~4~QC8mqZNq&reft=1591414635417&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/footmassager.png',
				// 		letters: '乐范脚部揉捏按摩器',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=k8CtKmFC4A&banner_id=f.79991533~image_ad.1~2~b1IsxZha&reft=1591414587092&spm=f.79991533'
				// 	}, {
				// 		svgName: 'IF',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/back.png',
				// 		letters: '人机工学背靠',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=U3ccaCzI8w&banner_id=f.79991533~image_ad.1~6~BO7PZtqG&reft=1591414609583&spm=f.79991533'
				// 	}, {
				// 		svgName: 'CGD',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/desk.png',
				// 		letters: '升降桌',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=08xZyF3tgO&banner_id=f.79991533~image_ad.1~3~td2do3Wf&reft=1591414707473&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/legmaddager.png',
				// 		letters: '腿部按摩器',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=oUXt3EE3Cl&banner_id=f.79991533~image_ad.1~5~e9pP9nDo&reft=1591414809672&spm=f.79991533'
				// 	}, {
				// 		svgName: '',
				// 		img: this.GLOBAL.imgHost + '/images/introduction/footbath.png',
				// 		letters: '折叠足浴盆',
				// 		arr: 'https://shop41582539.m.youzan.com/wscshop/showcase/feature?alias=Q5qmwPw4Mp&banner_id=f.79991533~image_ad.1~5~1gQOjY27&reft=1591414789961&spm=f.79991533'
				// 	},

				// ],
			}
		},
		mounted() {
			this.getProducList()
		},
		methods: {
			async getProducList() {
				// 获取数据
				// request.uniRequest('/product/getProductList')
				// 	.then(res => {
				// 		this.dataAry = res.data

				// 		console.log('test----video',this.dataAry);

				// 	}).catch(e => {})

				let res = await this.$Cloud.table(`lf_func_lefan_product`).get({
					page: 0,
					pageSize: 1000
				})

				console.log('获取商品列表====>>>>>>', res)

				const {
					code,
					data
				} = res
				if (code == 200) {
					this.dataAry = data.filter(item => item.is_check == 2)
				}
			},
			open(url) {

				// console.log(this.arr);
				if (url != '') {
					window.open(url, '_self')
				} else {
					// alert("视频正在更新中！");
					this.openMask("视频正在更新中！");
				}
			},
			openMask(text) {
				this.sendVal = true;
				this.tips = text;
			},
			clickCancel() {
				console.log('点击了取消');
			},
			clickDanger() {
				console.log('这里是danger回调')
			},
			clickConfirm() {
				console.log('点击了confirm');
			}
		},
	}
</script>

<style>
	.introduction {
		max-width: 33.75rem;
		margin: 0 auto;
	}

	.topView {
		width: 100%;
		height: 400px;
		background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#C3D2CD), to(#FFFFFF));
	}

	.topView .Maintitle {
		width: 100%;
		height: 7.75rem;
		font-size: 2rem;
		padding-top: 3.625rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		line-height: 5.75rem;
	}

	.MainView {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		width: 100%;
		flex-wrap: wrap;
		margin-top: -13.625rem;
		margin-bottom: 5.125rem;
	}

	.MainView .MainView-box {
		width: 50%;
		max-width: 11.875rem;
	}
</style>
